import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import '../../css/layout.css';


export function  HotelSlide () {

    let authenticatedClient_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedClient_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedClient_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedClient_context.baseURL);

    let [createRequisitionModal, setCeateRequisitionModal] = useState(false);
    let [viewRequistion_overviewModal, setViewRequistion_overviewModal]= useState(false);
    let [deleteRequisitionModal, setDeleteRequisitionModal] = useState(false);

    let [viewApplicationList, setViewApplicationList] = useState([]);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [requisitionResponsibilites, setRequisitionResponsibilites] = useState(false);
    let [requisitionQualifications, setRequisitionQualifications] = useState(false);
    let [requisitionDeadline, setRequisitionDeadline] = useState(false);

    let [showJobDescriptionModal, setShowJobDescriptionModal] = useState(false);

    let [viewInvoice, setViewInvoice] = useState(false);


    useEffect(() => {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                //Tracker: "74503_requisitions_overview",
                Tracker: "uu_retrieve_hotel_bookings_list",
                user: acctID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewApplicationList((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        bookingType: cols[0], 
                        room_id: cols[1], 
                        room_phone_number: cols[2], 
                        guest_first_name: cols[3], 
                        guest_last_name: cols[4], 
                        guest_phone_number: cols[5], 
                        guest_email_address: cols[6], 
                        guest_payment_type: cols[7], 
                        guest_member_number: cols[8], 
                        guest_cc_number: cols[9], 
                        guest_cc_service_code: cols[10],
                        guest_cc_exp_date: cols[11],
                        guest_cc_address: cols[12],
                        guest_cc_city: cols[13],
                        guest_cc_state: cols[14],
                        guest_cc_zip: cols[15],
                        guest_cc_cvv_num: cols[16],
                        guest_mm_provider: cols[17],
                        guest_mm_number: cols[18],
                        guest_checking_bank_name: cols[19],
                        guest_checking_number: cols[20],
                        guest_routing_number: cols[21],
                        room_price_per_night: cols[22],
                        room_guest_price: cols[23],
                        date_checked_in_booked: cols[24],
                        date_checked_out_booked: cols[25],
                        date_checked_in_actual: cols[26],
                        merchant_invoice_id: cols[27],
                        customer_invoice_id: cols[28],
                        attachment: cols[29],
                        activated_by_employee: cols[30],
                        check_in_id_type: cols[31],
                        check_in_id_number: cols[32],
                        attachment_id: cols[33],
                        booking_id: cols[34],
                        status: cols[35],
                        room_id_multiple: cols[36],
                        company_id: cols[37],
                        comapany_name: cols[38],
                        company_schema: cols[39],
                        customer_invoiceForm: cols[40],


    
                    })
                });
            } 
        })

    }, [])            
        


    return (
        <React.Fragment>

            <IonContent className='grid_content'>
                            <IonItem>
                                <IonGrid>
                                    <IonRow style={{color: 'black'}}>
                                        <IonCol>
                                            <h3> HOTEL BOOKINGS</h3>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow >
                                        <IonCol size='3' > <h5>NAME</h5></IonCol>
                                        <IonCol size='3' ><h5>ROOM #</h5></IonCol>
                                        <IonCol size='3'><h5>Check-In</h5></IonCol>
                                        <IonCol size='3'><h5>Status</h5></IonCol>
                                    </IonRow>
                                    </IonGrid>
                            </IonItem>
                            <IonGrid >
                                {viewApplicationList.map((detailData) =>   {
                                    return (
                                        <IonRow className='gridResultBody'>
                                            <IonCol size='3' >{detailData.comapany_name}</IonCol>
                                            <IonCol size='3' >{detailData.room_id}</IonCol>
                                            <IonCol size='3' >{detailData.date_checked_in_booked}</IonCol>
                                            <IonCol size='3' >
                                                {/*<IonButton  > Image </IonButton>*/}
                                                <IonButton  className='small_button' onClick={() => setViewInvoice(true)}> View </IonButton>
                                            </IonCol>

                                        {viewInvoice == true && <ViewInvoiceModal openModal={ viewInvoice } closeModal={() => setViewInvoice(false)} data={{
                                            fileLocation: `/api/form/${detailData.invoiceForm}/${schema}`, 
                                            }}></ViewInvoiceModal>}

                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>

                {/*{showJobDescriptionModal == true && 
                <JobDescriptionModal openModal={ showJobDescriptionModal } closeModal={() => setShowJobDescriptionModal(false)} data={{
                    requisitionID: requisitionID, 
                    requisitionName: requisitionName,
                    requisitionResponsibilites: requisitionResponsibilites,
                    requisitionQualifications: requisitionQualifications,
                    requisitionDeadline: requisitionDeadline,
                                        }}></JobDescriptionModal>}*/}


            </IonContent>

            </React.Fragment>

        )
}